import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Breadcrumbs,
  Link
} from '@mui/material';
import {
  Menu as MenuIcon,
  Notifications as NotificationsIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';

// Mapeo de rutas a títulos
const routeTitles = {
  '/dashboard': 'Dashboard',
  '/orders': 'Pedidos',
  '/providers': 'Proveedores',
  '/users': 'Usuarios'
};

// Mapeo de rutas a breadcrumbs
const routeBreadcrumbs = {
  '/dashboard': ['Dashboard'],
  '/orders': ['Pedidos'],
  '/providers': ['Proveedores'],
  '/users': ['Usuarios']
};

function AppHeader({ onMenuClick }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();

  // Obtener el título actual basado en la ruta
  const getCurrentTitle = () => {
    return 'Conlima: Gestión de Pedidos';
  };

  // Obtener los breadcrumbs actuales
  const getCurrentBreadcrumbs = () => {
    return routeBreadcrumbs[location.pathname] || ['Dashboard'];
  };

  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={0}
      sx={{
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Toolbar>
        {/* Botón de menú */}
        <IconButton
          color="inherit"
          aria-label="abrir menú"
          edge="start"
          onClick={onMenuClick}
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>

        {/* Título y breadcrumbs */}
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              fontWeight: 'bold',
              color: 'text.primary',
              display: { xs: 'none', sm: 'block' }
            }}
          >
            {getCurrentTitle()}
          </Typography>
          
          {/* Breadcrumbs - solo visibles en desktop */}
          <Breadcrumbs
            aria-label="breadcrumb"
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiBreadcrumbs-separator': {
                mx: 0.5
              }
            }}
          >
            {getCurrentBreadcrumbs().map((crumb, index) => (
              <Typography
                key={index}
                variant="caption"
                color={index === getCurrentBreadcrumbs().length - 1 ? 'text.primary' : 'text.secondary'}
                sx={{ fontWeight: index === getCurrentBreadcrumbs().length - 1 ? 'bold' : 'normal' }}
              >
                {crumb}
              </Typography>
            ))}
          </Breadcrumbs>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default AppHeader; 